import { getValidToken } from "utils/getValidToken";

/** DELETE request (no body). Use full URL including query string, e.g. /delete_mail?email_id=9 */
export async function deleteData(url) {
  const token = await getValidToken();

  const response = await fetch(url, {
    method: "DELETE",

    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,

      // 'X-API-Key': 'T3l3trelSeXAnLtxHoPTAUK7W1vqblC1zGbHnk1IJzI'
    }

  });

  const text = await response.text();
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${text}`);
  }

  if (!text) return null;
  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
}
